import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import { AddPaymentValidationSchema } from '../schemas/addPayment.schema';
import { unFormatCurrency } from '@/common/utils/unFormatters';

interface UseCreateBillPaymentProps {
  billId: string;
  onSuccess?: (response: AxiosResponse) => void;
  onError?: (error: AxiosError) => void;
}

export const useCreateBillPayment = ({ billId, onSuccess, onError }: UseCreateBillPaymentProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['createBillPayment', billId],
    mutationFn: async ({ form, pdf }: { form: AddPaymentValidationSchema; pdf?: File; }) => {
      const payment = {
        ...form,
        type: form.type?.value,
        paid_total: form.paid_total ? unFormatCurrency(form.paid_total) : undefined,
        pdf,
      };

      return privateAxios.postForm(`/billing/bills/${billId}/payments`, {
        payment,
      });
    },
    onSuccess,
    onError,
  });
};
